import BaseApiService from '../baseApi.service';

export default class PointMultiplierEventService extends BaseApiService {
  readonly basePath: string = 'point-multiplier-event/v1';
  constructor(props = null) {
    super(props);
  }
}
